<app-nav *ngIf="loginDisplay && hasAccess"></app-nav>
